import { render, staticRenderFns } from "./RecyclableBoxBatchInStore.vue?vue&type=template&id=bdd9ef22&scoped=true&"
import script from "./RecyclableBoxBatchInStore.vue?vue&type=script&lang=js&"
export * from "./RecyclableBoxBatchInStore.vue?vue&type=script&lang=js&"
import style0 from "./RecyclableBoxBatchInStore.vue?vue&type=style&index=0&id=bdd9ef22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd9ef22",
  null
  
)

export default component.exports